<style>
	.totalSlide-enter-active{
		animation: slideUp .2s ease-in;
		-webkit-animation: slideUp .2s ease-in;
	}
	.totalSlide-leave-active{
		animation: slideDown .2s ease-out;
		-webkit-animation: slideDown .2s ease-out;
	}
	@keyframes slideDown {
	  0% {
	    bottom: 0%;
	    opacity: 1;
	  }
	  100% {
	    bottom: -30%;
	    opacity: 0;
	  }
	}
	@keyframes slideUp {
	  0% {
	    bottom: -30%;
	    opacity: 0;
	  }
	  100% {
	    bottom: 0%;
	    opacity: 1;
	  }
	}
	@-webkit-keyframes slideDown {
	  0% {
	    bottom: 0%;
	    opacity: 1;
	  }
	  100% {
	    bottom: -30%;
	    opacity: 0;
	  }
	}
	@-webkit-keyframes slideUp {
	  0% {
	    bottom: -30%;
	    opacity: 0;
	  }
	  100% {
	    bottom: 0%;
	    opacity: 1;
	  }
	}
</style>
<template>
	<div>
		<transition name="totalSlide">
			<div class="billcount-detail-total" v-show="shown" @click="moveAni">
				<ul class="ui-listview" style="padding-bottom: 0">
					<li style="margin-bottom:0">
						<p class="allorderbill-list-p">合计：
							<span>共计{{totalSum.organ_num}}家{{name}}</span>
						</p>
						<ul class="ui-detail-listview ui-billcount-detail-listview">
							<li>订货金额：{{totalSum.order_bill_money}}元</li>
							<li>实收金额：{{totalSum.sum_money_recipient}}元</li>
							<li>订货单：共{{totalSum.order_bill_num}}张</li>
							<li>发货金额：{{totalSum.deliver_money}}元</li>
							<li>退货单：共{{totalSum.reverse_bill_num}}张</li>
							<li>退货金额：{{totalSum.reverse_money}}元</li>
							<li>发货减实收：{{(totalSum.deliver_money - totalSum.sum_money_recipient) | filterFloat}}元</li>
							<li>实收减退货：{{(totalSum.sum_money_recipient - totalSum.reverse_money) | filterFloat}}元</li>
						</ul>
					</li>
				</ul>
			</div>
		</transition>
		<div class="edi-total-second" v-show="!shown" @click="getTotal">合计</div>
	</div>
</template>

<script>
export default {
	props: {
		filter: {},
		href: String,
		name: String
	},
	data () {
		return {
			shown: false,
			totalSum: {}
		}
	},
	methods: {
		close () {
			this.shown = false
		},
		getTotal () {
			var val = this.href
			this.$http.post(val, this.filter).then((response) => {
				if (response.body.result) {
					this.shown = !this.shown
					this.totalSum = response.body.data
				}
			})
		},
		moveAni () {
			this.shown = !this.shown
		}
	}
}
</script>


// WEBPACK FOOTER //
// GetTotal.vue?3bf7a7ec